import { createTheme } from '@mui/material/styles';
import { componentOverrides } from './componentOverrides';

const typography = {
  fontFamily: '"Inter", sans-serif',
  h1_fontFamily: '"Inter", sans-serif',
  label_fontFamily: '"Inter", sans-serif',
};

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0f2550',
      light: '#42a5f5',
      dark: '#1a3a6b',
    },
    secondary: {
      main: '#9c27b0',
      light: '#ba68c8',
      dark: '#7b1fa2',
    },
    background: {
      default: '#f9fafb',
      paper: '#ffffff',
    },
    text: {
      primary: '#101828',
      secondary: '#757575',
    },
    sidebar: {
      logoTextColor: 'rgb(255, 255, 255)',
      logoSloganColor: '#b3b3b3',
      background: '#0f2550',
      text: '#4ade80',
      textSecondary: '#757575',
      divider: '#e0e0e0',
      hover: '#f5f5f5',
      active: '#e3f2fd',
      menuItem: {
        background: 'transparent',
        text: '#c2c0c0',
        textActive: '#4ade80',
        icon: '#c2c0c0',
        iconActive: '#4ade80',
        backgroundActive: '#4ade8042',
        backgroundHover: '#4ade801a',
      },
    },
    topbar: {
      background: '#ffffff',
      text: '#757575',
      textSecondary: '#e3f2fd',
      divider: '#1565c0',
      hover: '#1565c0',
    },
    footer: {
      background: '#ffffff',
      text: '#212121',
    },
  },
  typography,
  components: componentOverrides,
});
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#0078e1',
      light: '#e3f2fd',
      dark: '#025cab',
    },
    secondary: {
      main: '#ce93d8',
      light: '#f3e5f5',
      dark: '#ab47bc',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b3b3b3',
    },
    sidebar: {
      logoTextColor: 'rgb(255, 255, 255)',
      logoSloganColor: '#b3b3b3',
      background: '#1e1e1e',
      text: '#4ade80',
      textSecondary: '#757575',
      divider: '#e0e0e0',
      hover: '#f5f5f5',
      active: '#e3f2fd',
      menuItem: {
        background: 'transparent',
        text: '#c2c0c0',
        textActive: '#4ade80',
        icon: '#c2c0c0',
        iconActive: '#4ade80',
        backgroundActive: '#4ade8042',
        backgroundHover: '#4ade801a',
      },
    },
    topbar: {
      background: '#1e1e1e',
      text: '#ffffff',
      textSecondary: '#b3b3b3',
      divider: '#424242',
      hover: '#2d2d2d',
    },
    footer: {
      background: '#1e1e1e',
      text: '#ffffff',
    },
  },
  typography,
  components: componentOverrides,
});

